import { render, staticRenderFns } from "./AppEchartDoughnut.vue?vue&type=template&id=24055b7e&"
import script from "./AppEchartDoughnut.vue?vue&type=script&lang=js&"
export * from "./AppEchartDoughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports